export const getters = {
    getSuccess: (state) => state.success,
    getError: (state) => state.error,
    getErrors: (state) => state.errors,
};